import { render } from "./insure-daily-premium-record.vue?vue&type=template&id=232c14ad&scoped=true&ts=true"
import script from "./insure-daily-premium-record.vue?vue&type=script&lang=ts"
export * from "./insure-daily-premium-record.vue?vue&type=script&lang=ts"

import "./insure-daily-premium-record.vue?vue&type=style&index=0&id=232c14ad&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232c14ad"]])

export default __exports__